import { useDispatch, useSelector } from "react-redux";
import useProgramas from "./useProgramas";
import { TipoPrograma } from "../__enum";
import FormDadosPufv from "../listaPrograma/listaPeriodo/listaPeriodoItem/uniao/FormularioPeriodo";
import FormDadosCooperativa from "../listaPrograma/listaPeriodo/listaPeriodoItem/cooperativa/Modal/FormularioPeriodo";
import FormDadosFinancas from "../listaPrograma/listaPeriodo/listaPeriodoItem/financas/FomularioPeriodo";
import { openModal } from "store/modules/ModalActions";
import ModalProgramaPeriodo from "../components/Modais/ModalProgramaPeriodo";
import { setEnviarFormularioPeriodo } from "store/modules/EscolasActions";
import { RootState } from "store";

export const useModalPeriodoPrograma = () => {
    const dispatch = useDispatch();
    const { getPeriodoValidationKey, getTitleModal } = useProgramas();
    const languageValues = useSelector((state: RootState) => state.languages.languageValues);

    const openModalFormDados = ({
        key,
        tipoPrograma,
        id,
        periodo,
        idPeriodo,
        onRefresh,
    }: {
        key: "cadastrar" | "editar" | "duplicar";
        tipoPrograma: TipoPrograma;
        id: string;
        periodo?: string;
        idPeriodo?: string;
        onRefresh?: () => void;
    }) => {
        let FormularioPeriodo;

        const getLabelButton = (keyParam: "cadastrar" | "editar" | "duplicar"): string => {
            switch (keyParam) {
                case "duplicar":
                    return languageValues.duplicar;
                case "editar":
                    return languageValues.salvar;
                default:
                    return languageValues.cadastrar;
            }
        };

        const labelButton = getLabelButton(key);

        switch (tipoPrograma) {
            case TipoPrograma.UniaoFazAVida:
                FormularioPeriodo = <FormDadosPufv formKey={key} id={id} periodo={periodo} onRefresh={onRefresh} />;
                break;
            case TipoPrograma.CooperativaEscolar:
                FormularioPeriodo = <FormDadosCooperativa formKey={key} id={id} periodo={periodo} idPeriodo={idPeriodo} onRefresh={onRefresh} />;
                break;
            case TipoPrograma.FinancasNaMochila:
                FormularioPeriodo = <FormDadosFinancas formKey={key} id={id} periodo={periodo} idPeriodo={idPeriodo} onRefresh={onRefresh} />;
                break;
            default:
                FormularioPeriodo = <></>;
        }

        dispatch(
            openModal(ModalProgramaPeriodo, {
                modalKey: 'ModalProgramaPeriodo',
                validationKey: getPeriodoValidationKey(tipoPrograma),
                title: getTitleModal(tipoPrograma, key),
                content: FormularioPeriodo,
                confirmLabel: labelButton,
                cancelLabel: 'Cancelar',
                confirmThemeButton: 'button_PUFV',
                cancelThemeButton: 'button_PUFV',
                confirmCallback: async () => {
                    dispatch(setEnviarFormularioPeriodo(true));
                    onRefresh?.();
                },
                cancelCallback: () => {
                    onRefresh?.();
                },
            })
        );
    };

    return { openModalFormDados };
};

